// extracted by mini-css-extract-plugin
export default {"MainHeader":"MainHeader_MainHeader__1e+Km"};